import { z } from 'zod';

import { idSchema } from '../../../../shared/source/data-contract/id';
import { personSchema } from '../../position-management/person';

export const activityInputSchema = z.object({
    id: idSchema.optional(),
    activityDate: z.iso.datetime().optional(),
    activityStatus: z.enum(['recommended', 'planned', 'completed', 'declined']),
    chatMessageId: idSchema.optional(),
    createdBy: personSchema.optional(),
    description: z.string().optional(),
    recordId: idSchema.optional(),
    skillIds: idSchema.array(),
    title: z.string(),
    visibility: z.enum(['private', 'manager']),
});

export const activitySchema = activityInputSchema.extend({
    id: idSchema,
    createdAt: z.iso.datetime(),
});

export type Activity = z.infer<typeof activitySchema>;

export type ActivityInput = z.infer<typeof activityInputSchema>;
